import { useState } from 'react';
import { notification } from 'antd';
import Button from '@components/shared/V2Button';
import { useTranslation } from 'react-i18next';
import api from '@shared/api';
import PropTypes from 'prop-types';

const GenerateMediaDirectoryButton = ({ entityId, afterCreate, disabled, route }) => {
  const { t } = useTranslation('common');
  const [updating, setUpdatingState] = useState(false);

  const generateMediaDirectory = async () => {
    setUpdatingState(true);
    const response = await api.post(route, {
      entityId,
    });

    if (response.ok) {
      notification.success({ message: t('generateMediaDirectorySuccessMessage') });
      setUpdatingState(false);
      afterCreate();
    } else {
      notification.error({ message: t('generateMediaDirectoryFailureMessage') });
      setUpdatingState(false);
    }
  };

  return (
    <Button type="secondary" disabled={disabled || updating} onClick={generateMediaDirectory}>
      {t('generateMediaDirectory')}
    </Button>
  );
};

GenerateMediaDirectoryButton.defaultProps = {
  afterCreate: () => {},
};

GenerateMediaDirectoryButton.propTypes = {
  entityId: PropTypes.string.isRequired,
  afterCreate: PropTypes.func,
  route: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default GenerateMediaDirectoryButton;
